{
    "WebexAuth_UserIntro": "Hallo **{}**,",
    "WebexAuth_UserIntro_2": "CX Analytics benötigt Zugriff auf Ihren Webex Calling Tenant.",
    "WebexAuth_AdminConsent": "Erteilung der administrativen Zustimmung",
    "WebexAuth_Authorise": "Autorisieren",
    "WebexAuth_ConsentedMessage": "Administratorzustimmung erteilt, bitte klicken Sie auf „Autorisieren“, um fortzufahren.",
    "WebexAuth_AuthorisedMessage": "Genehmigung erteilt",
    "WebexAuth_Decline": "Abfall",
    "WebexAuth_Error_Unknown": "Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an Ihren Systemadministrator.",
    "NAME": "WebexAuthLanguage"
}